<template>
  <div class="mx-4" v-if="!loading">
    <div class="days mb-4">
      <div
        :class="index === 5 || index === 6 ? 'day-color' : ''"
        class="day"
        v-for="(day, index) in Object.keys(days)"
        :key="day"
      >
        <p>{{ day }}</p>
        <input
          v-model.number="days[day]"
          type="checkbox"
          max="24"
          min="0"
          step="1"
        />
      </div>
      <div :class="'day-color'" class="day">
        <p>Św.</p>
        <input v-model="holidays" type="checkbox" max="24" min="0" step="1" />
      </div>
    </div>

    <dod-custom-input
      label="MINIMALNA ILOŚĆ GODZIN"
      :placeholder="'Minimalna il. godz.'"
      :isRequired="true"
      type="number"
      @onType="(e) => (minNumberOfEmployeeHours = Number(e))"
      :startValue="minNumberOfEmployeeHours"
    />

    <div class="buttons">
      <custom-button
        title="Anuluj"
        :gradient="false"
        :gray="true"
        custom-styles="border-radius: 50px; width: 50%;"
        @click="cancelEditing"
      />
      <custom-button
        title="Zapisz"
        :gradient="true"
        custom-styles="border-radius: 50px; width: 50%;"
        @click="saveSchedule"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import CustomButton from "../CustomButton.vue";
import DodCustomInput from "./DodCustomInput.vue";
export default {
  components: { CustomButton, DodCustomInput },
  name: "EmployeeScheduleEditing",
  props: ["employeeId"],
  data: () => {
    return {
      days: {
        Pon: false,
        Wt: false,
        Śr: false,
        Czw: false,
        Pt: false,
        Sob: false,
        Nd: false,
      },
      holidays: false,
      minNumberOfEmployeeHours: 0,
      loading: true,
    };
  },
  mounted() {
    this.loading = true;
    if (this.schedule) {
      this.days.Pon = this.schedule.monday;
      this.days.Wt = this.schedule.tuesday;
      this.days.Śr = this.schedule.wednesday;
      this.days.Czw = this.schedule.thursday;
      this.days.Pt = this.schedule.friday;
      this.days.Sob = this.schedule.saturday;
      this.days.Nd = this.schedule.sunday;
      this.holidays = this.schedule.holidays;
      this.minNumberOfEmployeeHours = this.minNumberOfHours || 0;
    }
    this.loading = false;
  },
  methods: {
    getMinDateForNewSchedule() {
      return moment().add(1, "day").format("YYYY-MM-DD");
    },
    cancelEditing() {
      this.$emit("cancelEditing");
    },
    async saveSchedule() {
      const response = await this.$store.dispatch("editEmployeeSchedule", {
        employeeAvailabilityId: this.schedule.id,
        data: {
          employeeId: this.employeeId,
          holidays: Boolean(this.holidays),
          monday: this.days.Pon,
          tuesday: this.days.Wt,
          wednesday: this.days.Śr,
          thursday: this.days.Czw,
          friday: this.days.Pt,
          saturday: this.days.Sob,
          sunday: this.days.Nd,
          minimumNumberOfHours: this.minNumberOfEmployeeHours,
        },
      });
      if (response) {
        this.$notify({
          group: "success",
          text: "Zapotrzebowanie zostało zaktualizowane",
        });
        await this.$store.dispatch("getEmployeeAvailability", {
          employeeId: this.employeeId,
        });
      } else {
        this.$notify({
          group: "error",
          text: "Nie udało się zaktualizować zapotrzebowania",
        });
      }
    },
  },

  computed: {
    schedule() {
      return this.$store.getters.getDodSelectedEmployeeAvailability?.data
        ? this.$store.getters.getDodSelectedEmployeeAvailability?.data[0]
        : null;
    },

    minNumberOfHours() {
      return this.selectedEmployee.minimumNumberOfHours;
    },

    selectedEmployee() {
      return this.$store.getters.getDodSelectedEmployee;
    },
  },
};
</script>

<style scoped>
.box {
}
.days {
  border-radius: 5px;
  border: 1px solid rgba(9, 7, 65, 0.25);
  display: flex;
  width: 100%;
  margin: 0;
}
.day {
  border-right: 1px solid rgba(9, 7, 65, 0.25);
  flex: 1 1 0px;
  height: 54px;
  text-align: center;
}
.day:last-child {
  border-right: none;
}
.holidays-select {
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-left: 0.5rem;
  display: flex;
  align-items: center;
}
.holidays-select label {
  margin-bottom: 0;
  margin-left: 5px;
  cursor: pointer;
}
.holiday-input {
  cursor: pointer;
}
.buttons {
  display: flex;
  width: 100%;
  gap: 1rem;
}
.day input {
  border: none;
  text-align: center;
  border-bottom: 1px solid black;
  width: 100%;
  background: none;
}
.day input:focus {
  outline: none;
}
.day-color {
  background: rgba(226, 3, 126, 0.07);
}

.day input::-webkit-outer-spin-button,
.day input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.day input[type="number"] {
  -moz-appearance: textfield;
}
</style>